import createStore from "astrid-helpers/src/createStore";

export const [getShowRendered, setShowRendered, useShowRendered, onShowRendered] = createStore(false);
